// Nhãn cho kết quả đối soát kỳ thanh toán Shopee (admin/backend/services/shopeeValidationPlan.js)
import { formatCurrency } from './format';

export const VALIDATION_ACTIONS = {
  approved: { label: 'Duyệt', tone: 'green' },
  approved_adjusted: { label: 'Duyệt + chỉnh tiền', tone: 'blue' },
  approved_with_fraud: { label: 'Duyệt, huỷ item gian lận', tone: 'orange' },
  cancelled_fraud: { label: 'Huỷ do gian lận', tone: 'red' },
  cancelled: { label: 'Huỷ', tone: 'red' },
  kept_pending: { label: 'Giữ chờ', tone: 'yellow' },
  already_approved_changed: { label: 'Đã duyệt, Shopee báo khác', tone: 'purple' },
  already_approved: { label: 'Đã duyệt trước', tone: 'gray' },
  already_cancelled: { label: 'Đã huỷ trước', tone: 'gray' },
  not_in_db: { label: 'Không có trong hệ thống', tone: 'gray' },
  wrong_platform: { label: 'Không phải đơn Shopee', tone: 'gray' }
};

// Thứ tự hiển thị: nhóm cần chú ý trước
export const ACTION_ORDER = Object.keys(VALIDATION_ACTIONS);

// Hành động có ghi DB khi áp dụng
export const CHANGING_ACTIONS = ['approved', 'approved_adjusted', 'approved_with_fraud', 'cancelled_fraud', 'cancelled'];

export const actionMeta = (action) => VALIDATION_ACTIONS[action] || { label: action, tone: 'gray' };

// Lý do dạng "loại:model_id:..." → câu đọc được
export const describeReason = (reason) => {
  const [kind, model, ...rest] = String(reason).split(':');
  switch (kind) {
    case 'commission': {
      const [before, after] = rest.join(':').split('->');
      return `SP ${model}: hoa hồng ${formatCurrency(before)} → ${formatCurrency(after)}`;
    }
    case 'fraud': return `SP ${model}: Shopee đánh gian lận (FRAUD)`;
    case 'cancelled': return `SP ${model}: Shopee huỷ`;
    case 'missing_in_report': return `SP ${model}: có trong hệ thống nhưng không có trong báo cáo kỳ`;
    case 'extra_in_report': return `SP ${model}: có trong báo cáo nhưng không có trong hệ thống`;
    case 'invalid': return `SP ${model}: trạng thái chưa hợp lệ (${rest.filter(Boolean).join(' / ') || 'trống'})`;
    case 'status': return `SP ${model}: trạng thái ${rest.join(':')}`;
    case 'is_fraud': return `SP ${model}: bỏ cờ gian lận`;
    case 'no_matching_items': return 'Không sản phẩm nào trong hệ thống khớp báo cáo';
    default: return reason;
  }
};
